import { GetterTree } from "vuex";
import {
  INotificationState,
  INotification,
  IProcessInfoNotification,
} from "@/store/modules/notification/state";
import { IDataProvider, IRootState } from "@/store";

export enum NotificationGetters {
  GET_ALL = "GET_ALL_NOTIFICATION",
  GET_CURRENT = "GET_CURRENT_NOTIFICATION",
  GET_DATA_PROVIDER = "GET_DATA_PROVIDER_NOTIFICATION",
  GET_NOTIFICATION_COUNT = "GET_NOTIFICATION_COUNT",
  GET_PROCESS_INFO_NOTIFICATIONS = "GET_PROCESS_INFO_NOTIFICATIONS",
}

export const getters: GetterTree<INotificationState, IRootState> = {
  [NotificationGetters.GET_ALL](state): INotification[] | null {
    return state.notifications;
  },
  [NotificationGetters.GET_CURRENT](state): INotification | null {
    return state.notification;
  },
  [NotificationGetters.GET_DATA_PROVIDER](
    state
  ): IDataProvider<INotification> | null {
    return state.dataProvider;
  },
  [NotificationGetters.GET_NOTIFICATION_COUNT](state): number {
    return state.count;
  },
  [NotificationGetters.GET_PROCESS_INFO_NOTIFICATIONS](
    state
  ): IProcessInfoNotification[] {
    return state.processInfoNotifications;
  },
};
